import useAppContext from "./useAppContext";

const useProcessPathPairsContext = () => {
  // processPathPairs: [["PICK", "Y"], ..]
  const { processPathPairs } = useAppContext();
  return processPathPairs;
};

export default useProcessPathPairsContext;